import React from 'react';
import { Flexbox } from '@hiiretail/synergy-ui';
import styled from 'styled-components';

const headerHeight = '56px';
const breadcrumbsHeight = '74px';

const StyledFlexbox = styled(Flexbox)`
  width: 100%;
  height: calc(100% - (${headerHeight} + ${breadcrumbsHeight}));
  padding: 3.509vh 8.367vw;
  overflow: hidden;
  background-color: #eeeeee;
`;

export const NewPageWrapper: React.FC<React.PropsWithChildren> = ({ children }) => (
  //@ts-ignore
  <StyledFlexbox container item direction="column">
    {children}
  </StyledFlexbox>
);
